import { render } from "./ProductCards.vue?vue&type=template&id=0742bf7b&scoped=true"
import script from "./ProductCards.vue?vue&type=script&lang=js"
export * from "./ProductCards.vue?vue&type=script&lang=js"

import "./ProductCards.vue?vue&type=style&index=0&id=0742bf7b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0742bf7b"]])

export default __exports__